/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {
  $(document).on("change", ".trigger_sp__select", function name(params) {
    var $el = $(this),
      $wrap = $el.closest(".rc_radio_wrapper");
    $wrap.find(".rcr_input").attr("data-plan-id", $el.val());
    $('[action="/cart/add"] [name="selling_plan"]').val($el.val());
  });

  const $stickCart = $(".fixed-bottom-bar");
  const $reference = $(".custom-container");

  if ($stickCart.length && $reference.length) {
    $(window).on("scroll", function () {
      const scrollPosition = $(window).scrollTop();
      const referenceOffset = $reference.offset().top;
      const referenceHeight = $reference.outerHeight();
      const windowHeight = $(window).height();
      const bottomOfReference = referenceOffset + referenceHeight + 100;
      const bottomOfWindow = scrollPosition + windowHeight;

      if (
        bottomOfWindow > bottomOfReference &&
        scrollPosition < bottomOfReference
      ) {
        $stickCart.removeClass("stickky");
      } else {
        $stickCart.addClass("stickky");
      }
    });
  }

  var selected_rc_val = $('[name="rc-widget-custom"]:checked').val();
  $(".rc_hidden__sticky_htm").each(function (index) {
    var val = $(this).find("li").attr("data-value");
    $(".stickCartForm .dropdown__menu").append($(this).html());
    console.log(selected_rc_val, val, "<<<<<<TTER");
    if (selected_rc_val == val) {
      $(".stickCartForm .dropdown__toggle").html($(this).find("li").html());
    }
  });

  $(".dropdown").each(function () {
    $(this).on("click", function () {
      $(this).toggleClass("dropdown_open");
    });

    $(this).on("mouseover", function () {
      $(this).addClass("dropdown_open");
    });

    $(this).on("mouseout", function () {
      $(this).removeClass("dropdown_open");
    });
  });

  $(document).on(
    "click",
    ".stickCartForm .dropdown__menu .dropdown__item",
    function () {
      var $el = $(this),
        val = $el.attr("data-value"),
        htm = $el.html();
      $(`[name="rc-widget-custom"][value="${val}"]`).click();
      $(".stickCartForm .dropdown__toggle").html(htm);
    }
  );

  if ($('[name="rc-widget-custom"]').length) {
    $(".custom-ProductForm__BuyButtons .ProductForm__AddToCart").html(
      `<span class="atc_txt">ADD TO CART</span>&nbsp;-&nbsp;${$(
        '[name="rc-widget-custom"]'
      ).attr("data-price-money")}`
    );
    $(document).on("change", '[name="rc-widget-custom"]', function () {
      var $el = $(this),
        $wrap_item = $el.closest(".rc_radio_wrapper"),
        $wrap = $el.closest(".rc-widget__wrapper"),
        val = $el.val(),
        price = $el.attr("data-price"),
        price_money = $el.attr("data-price-money"),
        planId = $el.attr("data-plan-id") || null,
        vId = $el.attr("data-variant-id"),
        productId = $el.closest(".rc_radio_item").attr("data-parent-product");
      // console.log(price, price_money, val, productId);
      $wrap.find(".rc_radio_con").slideUp();
      $wrap.find(".rc_radio_wrapper").removeClass("active");
      $wrap_item.find(".rc_radio_con").slideDown();
      $wrap_item.addClass("active");
      $(".custom-ProductForm__BuyButtons .ProductForm__AddToCart").html(
        `<span class="atc_txt">ADD TO CART</span>&nbsp;-&nbsp;${price_money}`
      );
      $(".custom-ProductForm__BuyButtons").show();
      $('[action="/cart/add"] [name="selling_plan"]').val(planId);
      $('[action="/cart/add"] [name="id"]').val(vId);
      
      // Handle different products (for 3-month subscriptions that are separate products)
      if (val === "subsave_addon" && productId) {
        // For 3-month subscriptions, update the cart form to submit the 3-month product
        console.log('UPDATING FORM for 3-month subscription - vId:', vId, 'planId:', planId);
        
        // The form fields are already updated above (lines 118-119), but ensure they're correct
        $('form[action="/cart/add"], form[action*="/cart/add"]').each(function() {
          $(this).find('input[name="id"]').val(vId);
          if (planId) {
            if ($(this).find('input[name="selling_plan"]').length === 0) {
              $(this).append(`<input type="hidden" name="selling_plan" value="${planId}">`);
            } else {
              $(this).find('input[name="selling_plan"]').val(planId);
            }
          }
          console.log('Updated form with id:', vId, 'selling_plan:', planId);
        });
        
        // Store flag that form is updated for 3-month
        window.threemonthFormUpdated = true;
        window.addonUrl = null; // Clear addon URL so normal form submission happens
      } else {
        // Reset forms to use the regular product for other options
        window.threemonthFormUpdated = false;
        window.addonUrl = null;
        console.log('Using normal cart form for:', val);
      }
      $(".stickCartForm .dropdown__toggle").html(
        $(
          `.stickCartForm .dropdown__menu .dropdown__item[data-value=${val}]`
        ).html()
      );
    });
  }

  function updateQuantity($input, delta) {
    let newVal = Math.max(1, Math.min(Number($input.val()) + delta, 100));
    $input.val(newVal);
    $('[name="quantity"]').val(newVal);
  }

  $(document).on(
    "click",
    ".stickCartForm .QuantitySelector__Button",
    function () {
      const $input = $(this)
        .closest(".QuantitySelector")
        .find(".QuantitySelector__CurrentQuantity");
      updateQuantity($input, $(this).hasClass("minus") ? -1 : 1);
    }
  );

  $(document).on("click", ".stickCartForm .Submit__Button", function () {
    if (window.threemonthFormUpdated) {
      console.log('STICKY CART clicked - form updated for 3-month subscription, using normal submission');
    } else {
      console.log('STICKY CART clicked - using normal form submission');  
    }
    // Let normal button click happen - form fields are already updated for 3-month products
    $('[data-action="add-to-cart"]').click();
  });

  $(document).on("change", ".QuantitySelector__CurrentQuantity", function () {
    $(".stickCartForm .QuantitySelector__CurrentQuantity").val($(this).val());
  });

  // Simple logging for ADD TO CART clicks - let normal form submission happen
  $(document).on("click", '[data-action="add-to-cart"], button[name="add"], .btn--add-to-cart, input[type="submit"], button[type="submit"]', function (e) {
    if (window.threemonthFormUpdated) {
      console.log('ADD TO CART clicked - form updated for 3-month subscription, using normal submission');
    } else {
      console.log('ADD TO CART clicked - using normal form submission');
    }
    // Let normal form submission happen - this will trigger slidecarthq.js correctly
  });

  // Let normal form submissions happen for all cases
  $(document).on("submit", 'form[action="/cart/add"]', function (e) {
    if (window.threemonthFormUpdated) {
      console.log('FORM SUBMIT - form updated for 3-month subscription, allowing normal submission');
    } else {
      console.log('FORM SUBMIT - allowing normal form submission');
    }
    // Let normal form submission happen - this will trigger slidecarthq.js correctly
  });
}); //ready
